/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Groupsinvitelink2Inputs */

const en_groupsinvitelink2 = /** @type {(inputs: Groupsinvitelink2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invite link`)
};

const de_groupsinvitelink2 = /** @type {(inputs: Groupsinvitelink2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einladungslink`)
};

/**
* | output |
* | --- |
* | "Invite link" |
*
* @param {Groupsinvitelink2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const groupsinvitelink2 = /** @type {((inputs?: Groupsinvitelink2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Groupsinvitelink2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_groupsinvitelink2(inputs)
	return de_groupsinvitelink2(inputs)
});
export { groupsinvitelink2 as "groupsInviteLink" }